// extracted by mini-css-extract-plugin
export default {"user-registration__card":"UserRegistration_user-registration__card__kCGOL"};